import React from 'react';
import { journeyImages } from '../../data/journeyImages';

export const WellnessImage = ({ name, testId, className = '', sizes }) => {
  const { file, width, height, alt } = journeyImages[name];
  return (
    <div className={`hbk-wellness-image ${className}`} data-testid={`${testId}-frame`}>
      <img
        src={`/images/journey/${file}-320.webp`}
        srcSet={`/images/journey/${file}-320.webp 320w, /images/journey/${file}-640.webp 640w`}
        sizes={sizes}
        width={width}
        height={height}
        alt={alt}
        loading="lazy"
        decoding="async"
        data-testid={testId}
      />
    </div>
  );
};